import { Box } from "@chakra-ui/react";
import { ColorIcon } from "goi_common";
import { BaseStack } from "../../layout";
import { baseColors, baseRadius } from "../../tokens";

export interface InfoCalloutProps {
  children: React.ReactNode;
  className?: string;
}

/** 안내 콜아웃 박스 (아이콘 + 회색 배경 텍스트). Figma "Icon/Normal/CircleInfo" + Info 컴포넌트 기준. */
export function InfoCallout({
  children,
  className = "label_1_r",
}: InfoCalloutProps) {
  return (
    <BaseStack
      direction="horizontal"
      spacing={4}
      width="100%"
      alignItems="flex-start"
      padding="8px"
      bg={baseColors.fill_normal}
      borderRadius={`${baseRadius.rad_6}px`}
    >
      <Box padding={1}>
        <ColorIcon name="icon-circle-info-mono" size={20} />
      </Box>
      <Box
        flex={1}
        className={className}
        color={baseColors.label_alternative_1}
        style={{ whiteSpace: "pre-wrap", textAlign: "left" }}
      >
        {children}
      </Box>
    </BaseStack>
  );
}
